module.exports = __webpack_public_path__ + "img/kopsurat_binaumat.43a10ad7.png";